import React from "react";
import Home_Component from "../Components/Home_Component";
import Navbar from "../Components/Navbar";

function Home() {
  return (
    <div>
      <Navbar />
      <Home_Component />
    </div>
  );
}

export default Home;
